module.exports = __webpack_public_path__ + "img/love.e40bbb0f.jpg";